import { UpsMasterShipmentsStore } from "../../interfaces";
import { UpsMasterShipmentTypes } from "../types";

const initialState: UpsMasterShipmentsStore = {
    items: [],
    detail: null,
    selectedGccn: null,
    statusFilter: "OPEN",
    loading: false,
    detailLoading: false,
    actionLoading: false,
    error: null,
};

export const upsMasterShipments = (
    state = initialState,
    action: { type: string; payload?: Partial<UpsMasterShipmentsStore> }
): UpsMasterShipmentsStore => {
    switch (action.type) {
        case UpsMasterShipmentTypes.LIST_LOADING:
            return { ...state, loading: true, error: null };
        case UpsMasterShipmentTypes.LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                items: action.payload?.items ?? state.items,
                statusFilter: action.payload?.statusFilter ?? state.statusFilter,
                error: null,
            };
        case UpsMasterShipmentTypes.LIST_FAILURE:
            return { ...state, loading: false, error: action.payload?.error ?? "Error" };

        case UpsMasterShipmentTypes.DETAIL_LOADING:
            return { ...state, detailLoading: true, error: null };
        case UpsMasterShipmentTypes.DETAIL_SUCCESS:
            return {
                ...state,
                detailLoading: false,
                detail: action.payload?.detail ?? null,
                selectedGccn: action.payload?.selectedGccn ?? state.selectedGccn,
                error: null,
            };
        case UpsMasterShipmentTypes.DETAIL_FAILURE:
            return { ...state, detailLoading: false, error: action.payload?.error ?? "Error" };

        case UpsMasterShipmentTypes.ACTION_LOADING:
            return { ...state, actionLoading: true, error: null };
        case UpsMasterShipmentTypes.ACTION_SUCCESS:
            return {
                ...state,
                actionLoading: false,
                detail: action.payload?.detail ?? state.detail,
                error: null,
            };
        case UpsMasterShipmentTypes.ACTION_FAILURE:
            return { ...state, actionLoading: false, error: action.payload?.error ?? "Error" };

        case UpsMasterShipmentTypes.SET_SELECTED:
            return { ...state, selectedGccn: action.payload?.selectedGccn ?? null };
        case UpsMasterShipmentTypes.SET_STATUS_FILTER:
            return { ...state, statusFilter: action.payload?.statusFilter ?? state.statusFilter };

        default:
            return state;
    }
};
